import React from 'react';

import { getLocale } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';

interface FormattedDateProps {
    date?: string | number | Date;
    dateFormat?: Intl.DateTimeFormatOptions;
    className?: string;
}

export const DEFAULT_DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
};

const isValidDate = (date?: string | number | Date): boolean => {
    if (!date) return false;
    if (typeof date === 'number') return true;
    if (date instanceof Date) return !Number.isNaN(date.getTime());
    return date.replace(/[0-]+/g, '') !== '';
};

export const FormattedDate: React.FC<FormattedDateProps> = ({
    date,
    dateFormat = DEFAULT_DATE_TIME_FORMAT,
    className = '',
}) => {
    const locale = useAppSelector(getLocale) || 'en-GB';
    if (!isValidDate(date)) {
        return '-';
    }
    const formattedDate = Intl.DateTimeFormat(locale, dateFormat).format(new Date(date!)).replace(',', '');

    return <span className={`FormattedDate ${className}`}>{formattedDate}</span>;
};

export default FormattedDate;
